import { VERSION } from "../../constants/env";
class BaseLoggingModule {
  constructor() {
    this.region = "";
    this.bid = "";
    this.debug = false;
  }
  init(config) {
    const { region = "", bid = "", debug = false } = config != null ? config : {};
    this.region = region;
    this.bid = bid;
    this.debug = debug;
  }
  send(event) {
  }
  info(message, data) {
  }
  warn(message, data) {
  }
  error(message, data) {
  }
  getMeta(...args) {
    return {
      version: VERSION,
      bid: this.bid,
      region: this.region
    };
  }
  reportCUJ(name, status, data) {
  }
  destruct() {
  }
}
var BaseLoggingModule_default = BaseLoggingModule;
export {
  BaseLoggingModule_default as default
};
